import Vue from 'vue'
import Router from 'vue-router'
// import scrollBehavior from './scroll'

import VolunteerRoutes from './volunteer'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.SITE_BASE_URL,
  routes: [
    VolunteerRoutes
  ]
})

// router.beforeEach((to, from, next) => {
//   window.prerenderReady = false
//   console.log('prerender not ready')
//   next()
// })

export default router
